import styled from 'styled-components';
import {
  Row,
  MenShowingSuccess as DefaultMenShowingSuccess,
  Text,
} from '~components';

export const MenShowingSuccess = styled(DefaultMenShowingSuccess)`
  display: block;
  border-bottom: 1px solid ${({ theme }) => theme.color.border.neutral.default};
  margin-left: auto;
  margin-right: auto;
  margin-top: ${({ theme }) => theme.spacing.km10};
  margin-bottom: ${({ theme }) => theme.spacing.km10};
`;

export const Container = styled.section`
  margin-top: ${({ theme }) => theme.spacing.km10};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const Content = styled.section``;

export const RadioGroup = styled(Row)`
  width: 100%;

  & > :first-child {
    margin-right: 108px;
  }
`;

export const Description = styled(Text)`
  color: ${({ theme }) => theme.color.text.neutral.default};
  letter-spacing: -0.03em;
  margin-bottom: ${({ theme }) => theme.spacing.km3};
`;
